"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ShowSetting: true,
  ShowSettingPage: true,
  SHOW_TYPE_TIMEOUT: true,
  SHOW_TYPE_PERCENT_SCROLLED_HIDE_AGAIN: true,
  SHOW_TYPE_PERCENT_SCROLLED: true,
  SHOW_TYPE_HIDE: true,
  SHOW_TYPE_IMMEDIATELY: true
};
Object.defineProperty(exports, "SHOW_TYPE_HIDE", {
  enumerable: true,
  get: function () {
    return _ShowSetting.SHOW_TYPE_HIDE;
  }
});
Object.defineProperty(exports, "SHOW_TYPE_IMMEDIATELY", {
  enumerable: true,
  get: function () {
    return _ShowSetting.SHOW_TYPE_IMMEDIATELY;
  }
});
Object.defineProperty(exports, "SHOW_TYPE_PERCENT_SCROLLED", {
  enumerable: true,
  get: function () {
    return _ShowSetting.SHOW_TYPE_PERCENT_SCROLLED;
  }
});
Object.defineProperty(exports, "SHOW_TYPE_PERCENT_SCROLLED_HIDE_AGAIN", {
  enumerable: true,
  get: function () {
    return _ShowSetting.SHOW_TYPE_PERCENT_SCROLLED_HIDE_AGAIN;
  }
});
Object.defineProperty(exports, "SHOW_TYPE_TIMEOUT", {
  enumerable: true,
  get: function () {
    return _ShowSetting.SHOW_TYPE_TIMEOUT;
  }
});
Object.defineProperty(exports, "ShowSetting", {
  enumerable: true,
  get: function () {
    return _ShowSetting.ShowSetting;
  }
});
Object.defineProperty(exports, "ShowSettingPage", {
  enumerable: true,
  get: function () {
    return _ShowSetting.ShowSettingPage;
  }
});
var _Attribute = require("./Attribute");
Object.keys(_Attribute).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Attribute[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Attribute[key];
    }
  });
});
var _common = require("./common");
Object.keys(_common).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _common[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _common[key];
    }
  });
});
var _CustomConfig = require("./shop/CustomConfig");
Object.keys(_CustomConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CustomConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CustomConfig[key];
    }
  });
});
var _WebsiteChatConfig = require("./shop/WebsiteChatConfig");
Object.keys(_WebsiteChatConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _WebsiteChatConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WebsiteChatConfig[key];
    }
  });
});
var _CustomerConfig = require("./shop/CustomerConfig");
Object.keys(_CustomerConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CustomerConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CustomerConfig[key];
    }
  });
});
var _tracking = require("./tracking");
Object.keys(_tracking).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tracking[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tracking[key];
    }
  });
});
var _message = require("./message");
Object.keys(_message).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _message[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _message[key];
    }
  });
});
var _MetricEvent = require("./metricEvent/MetricEvent");
Object.keys(_MetricEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MetricEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MetricEvent[key];
    }
  });
});
var _ChatchampMessage = require("./ChatchampMessage");
Object.keys(_ChatchampMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ChatchampMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ChatchampMessage[key];
    }
  });
});
var _ChatBubbleMessage = require("./ChatBubbleMessage");
Object.keys(_ChatBubbleMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ChatBubbleMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ChatBubbleMessage[key];
    }
  });
});
var _WelcomeMessage = require("./welcomeMessage/WelcomeMessage");
Object.keys(_WelcomeMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _WelcomeMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WelcomeMessage[key];
    }
  });
});
var _WebhookMessage = require("./WebhookMessage");
Object.keys(_WebhookMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _WebhookMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WebhookMessage[key];
    }
  });
});
var _wizard = require("./wizard");
Object.keys(_wizard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _wizard[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _wizard[key];
    }
  });
});
var _WizardPage = require("./WizardPage");
Object.keys(_WizardPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _WizardPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WizardPage[key];
    }
  });
});
var _Language = require("./Language");
Object.keys(_Language).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Language[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Language[key];
    }
  });
});
var _Currency = require("./Currency");
Object.keys(_Currency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Currency[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Currency[key];
    }
  });
});
var _product = require("./product");
Object.keys(_product).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _product[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _product[key];
    }
  });
});
var _Routing = require("./Routing");
Object.keys(_Routing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Routing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Routing[key];
    }
  });
});
var _Chat = require("./Chat");
Object.keys(_Chat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Chat[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Chat[key];
    }
  });
});
var _customerService = require("./customerService");
Object.keys(_customerService).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _customerService[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _customerService[key];
    }
  });
});
var _integrations = require("./integrations");
Object.keys(_integrations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _integrations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _integrations[key];
    }
  });
});
var _ShowSetting = require("./shop/ShowSetting");